import React, { useContext, useCallback, useEffect, useState } from "react";
import { AppContext, DispatchContext } from "../AppContext";
import { useDropzone } from 'react-dropzone';
import { makeStyles } from "@material-ui/styles";
import FileUploadCards from "./FileUploadCards";
import { LinearProgress, Typography } from '@material-ui/core';
import ReactDOM from 'react-dom';
import FolderOpenOutlinedIcon from '@material-ui/icons/FolderOpenOutlined';
import CancelIcon from '@material-ui/icons/Cancel';
import { ReactComponent as UploadingIcon } from '../assets/icons/uploading.svg';
import Service from "../services/service";
import * as actions from '../actions/actions';
import { createUUID, getCookie, config, formatFileSize, resolveNotificationMessage } from '../helpers/constants';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles((theme) => ({
    root: {
        overflow: "hidden",
        flexDirection: "column",
        display: "flex",
        height: "100%",
    },
    drag_drop_container: {
        overflow: "auto",
        flexDirection: "column",
        display: "flex",
        height: "100%",
        borderBottom: "1px solid #dddddd",
        padding: "10px",
        cursor: "pointer",
        '&:focus': {
            outline: 'none'
        },
    },
    heading: {
        padding: theme.spacing(1),
        fontSize: "1rem",
    },
    flex_auto: {
        flex: '1 1 auto',
    },
    overflow_hidden: {
        overflow: "auto",
    },
    icon_container: {
        marginLeft: 'auto',
    },

}))

let uploadedFiles = [];
let xhrs = [];
let uploadStatusTimer = 0;

export default function FileUploadPanel(props) {

    const dispatch = useContext(DispatchContext);
    const state = useContext(AppContext);
    const s = state.strings;
    const classes = useStyles(state);

    useEffect(() => {
        return () => {
            clearInterval(uploadStatusTimer);
            dispatch(actions.cancelFilesUpload());
            uploadedFiles = [];
            xhrs.map((x) => x.abort());
            xhrs = [];
            // todo: abort xhr for all files
        };
    }, []);

    const onDrop = useCallback(acceptedFiles => {

        let maxAllowedCount = config.maxNumberFileUpload - uploadedFiles.length;
        if (acceptedFiles.length > maxAllowedCount) {
            let skippedCount = acceptedFiles.length - maxAllowedCount;
            dispatch(actions.openToast({ type: "warning", message: s.newCheck.filesTruncated.format(config.maxNumberFileUpload, skippedCount), status: true }));
            acceptedFiles = acceptedFiles.slice(0, maxAllowedCount);
        }

        acceptedFiles.map(file => {
            const uuid = createUUID();
            file.id = uuid;
        })

        dispatch(actions.setUploadedFiles(acceptedFiles));

        acceptedFiles.map((file, i) => {
            const uuid = file.id;
            const formData = new FormData();
            formData.append('file', file);
            formData.append('uploadid', uuid);
            formData.append('sid', getCookie(config.sessionCookieName));
            if (document.getElementById(uuid)) {
                ReactDOM.render(<LinearProgress variant="determinate" value={0} />, document.getElementById(uuid))
            }
            let xhr = new XMLHttpRequest();
            xhrs.push(xhr);

            xhr.upload.onprogress = (e) => {
                const pct = +((e.loaded / e.total) * 100).toFixed(2);
                if (document.getElementById(uuid + '_status')) {
                    ReactDOM.render(`${formatFileSize(e.loaded)} / ${formatFileSize(e.total)} (${pct})%`, document.getElementById(uuid + '_status'));
                }
                if (document.getElementById(uuid)) {
                    ReactDOM.render(pct !== 100 ? <LinearProgress variant="determinate" value={pct} /> : <LinearProgress value={pct} />, document.getElementById(uuid))
                }
            };
            uploadedFiles.push(uuid)
            xhr.onreadystatechange = () => {

                if (xhr.readyState !== 4) return;   // 4: DONE
                if (xhr.status !== 200) {
                    return;
                }
                const response = JSON.parse(xhr.response)
                if (response && !response.success) {
                    onUploadedDeleteFile(uuid);
                    dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(response.errors[0], s.notificationMessage), status: true }))
                }
                /*handle success*/
            };

            xhr.open("post", config.backendUrl + "api/UploadFile");
            xhr.send(formData);
        });

        getUploadedFilesStatus(uploadedFiles)

    }, []);


    const getUploadedFilesStatus = (uploadids) => {

        clearInterval(uploadStatusTimer);

        uploadStatusTimer = setInterval(() => {
            Service.getUploadedFilesStatus(uploadids).then(res => {

                res.data.Files && res.data.Files.filter(f => f.Status == "Error").map(f => {
                    onUploadedDeleteFile(f.UploadId);
                    dispatch(actions.openToast({ type: "error", message: s.newCheck.uploadError, status: true }))
                });

                if (res.data.PendingCount === 0 && res.total !== 0 && uploadids.length === res.total) {
                    clearInterval(uploadStatusTimer);
                }
                dispatch(actions.setUploadedFilesStatus(res.data))
                // check if there are files in status=Error and delete them from the list

            })
        }, 2500);
    }


    const chooseMultipleFiles = (id) => {
        let item = document.getElementById(id);
        item.click();
    }

    const onCancelAllFilesUpload = () => {
        xhrs.map((x) => x.abort());
        xhrs = [];
        uploadedFiles = [];
        clearInterval(uploadStatusTimer);
        dispatch(actions.cancelFilesUpload());
        dispatch(actions.setUploadedFilesStatus({ Files: [] }))
    }

    const onUploadedDeleteFile = (id) => {
        // todo: abort xhr for this file
        uploadedFiles = uploadedFiles.filter(file => file !== id);
        if (uploadedFiles.length > 0) {
            getUploadedFilesStatus(uploadedFiles)
        }
        else {
            onCancelAllFilesUpload();
        }
        dispatch(actions.removeUploadedFile(id));
    }

    const onUploadedEditFile = (id) => {
        dispatch(actions.openConfirmationDialog({
            title: s.newCheck.editTextTitle,
            text: s.newCheck.editTextDesc,
            onConfirm: () => onConfirmEditFile(id),
        }));
    }

    const onConfirmEditFile = (id) => {
        var editFiles = state.uploadedFilesStatus.filter(fs => fs.UploadId == id);
        if (editFiles.length > 0) {
            Service.getUploadedFileInfo(editFiles[0].UploadId, true).then(res => {
                if (res.success) {
                    dispatch(actions.setNewCheckSettings({ source: 'text', text: res.data.text, libraryTexts: [] }));
                } else {
                    dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(res.errors[0], s.notificationMessage) }));
                }
            });
        }
    }


    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

    let uploadedOkCount = state.uploadedFilesStatus.filter(file => file.Status == "Ok").length;

    return (
        <div className={classes.root} >
            <div className={`${classes.flex_auto} ${classes.overflow_hidden}`} >

                <div className={classes.drag_drop_container} {...getRootProps()}>
                    <input {...getInputProps()} />
                    {state.uploadedFiles.length > 0 ?
                        <FileUploadCards acceptedFiles={state.uploadedFiles} fileStatus={state.uploadedFilesStatus} onUploadedDeleteFile={onUploadedDeleteFile} onUploadedEditFile={onUploadedEditFile} isDragActive={isDragActive} /> :

                        isDragActive ?
                            <div style={{ padding: 20, borderRadius: 5, border: "2px solid #0D4A81", backgroundColor: "#eeeeee", width: "100%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                                <UploadingIcon fill="#1982DD" height={100} width={100} style={{ marginBottom: 16 }} />
                                <Typography align="center">{s.newCheck.dropHere}</Typography>
                            </div> :
                            <div style={{ padding: 20, borderRadius: 5, border: "2px dotted #0D4A81", width: "100%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                                <UploadingIcon fill="#0D4A81" height={100} width={100} style={{ marginBottom: 16 }} />
                                <Typography paragraph align="center">{s.dragYourFileHere}</Typography>
                                <Typography variant="body2" color="secondary" align="center">{s.newCheck.parallelUpload.format(config.maxNumberFileUpload)}</Typography>
                                <Typography variant="body2" color="secondary" align="center">{s.newCheck.supportFileFormats}</Typography>
                                <Typography variant="body2" color="secondary" align="center">{s.newCheck.maxFileSize}</Typography>
                            </div>
                    }

                </div>

            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ flex: "0 0 auto", marginLeft: 8 }}>
                    <Typography>{s.newCheck.overallProgress.format(uploadedOkCount, state.uploadedFiles.length)}</Typography>
                </div>
                <div style={{ flex: "1 1 auto", marginLeft: 16, marginRight: 16 }}>
                    {state.uploadedFiles.length > 0 &&
                        <LinearProgress variant="determinate" value={100.0 * uploadedOkCount / state.uploadedFiles.length} />}
                </div>
                <div style={{ flex: "0 0 auto" }}>
                    <IconButton onClick={() => chooseMultipleFiles('chooseMultipleVesselDoc')}>
                        <FolderOpenOutlinedIcon />
                    </IconButton>
                    <input {...getInputProps()} id="chooseMultipleVesselDoc" name="New Document" style={{ display: 'none' }} />
                    <IconButton onClick={() => onCancelAllFilesUpload()}>
                        <CancelIcon />
                    </IconButton>
                </div>
            </div>
        </div>
    )
}